/**
 * 茶仓管理
 */
/**
 * 茶仓管理实体类
 */
export interface TeaStorageMaintain{
  name:string
  equipmentId:number|0
  dtuNumber:string
  sort:number|0
  powderValue:number|0
  fullValue:number|0
  warningValue:number|0
  remaining:number|0
}

export interface ApiResponse<T = any> {
  code: string | number
  message: string
  data: T
  success: boolean
}

export class TeaMaintainService{
  private baseUrl: string = 'api/teaMaintain'
  private httpService: any

  constructor(httpService?: any) {
    this.httpService = httpService
  }

  /**
   * 创建服务实例（便捷方法）
   */
  static create(httpService?: any): TeaMaintainService {
    return new TeaMaintainService(httpService)
  }

  async getMaintain(params?:{
    equipmentId?:number|0,
    dtuNumber?:string
  }){
    const http = this.httpService || this.getHttpService()
    if (!http) {
      return this.handleError(new Error('HTTP服务未初始化'))
    }
    const queryParams: Record<string, any> = {}

    if(params && params.equipmentId) queryParams.equipmentId = params.equipmentId
    if(params && params.dtuNumber) queryParams.dtuNumber = params.dtuNumber

    try{
      const response = await http.get(`${this.baseUrl}`,queryParams)
      return this.handleResponse(response)
    }catch (err){
      return this.handleError(err)
    }
  }

  async saveMaintain(data:{
    id?: number | 0
    name: string
    sort: number | 0
    equipmentId: number | 0
    dtuNumber: string
    powderValue: number | 0
    fullValue: number | 0
    warningValue: number | 0
    remaining: number | 0
  }){
    const http = this.httpService || this.getHttpService()
    if (!http) {
      return this.handleError(new Error('HTTP服务未初始化'))
    }
    try{
      const response = data && data.id ? await http.post(`${this.baseUrl}?source=1`, data) : await http.post(`${this.baseUrl}`, data)
      return this.handleResponse(response)
    }catch (err){
      return this.handleError(err)
    }
  }

  async ToggleRawMaintain(params?: {
    equipmentId?: number | 0
  }) {
    const http = this.httpService || this.getHttpService()
    if (!http) {
      return this.handleError(new Error('HTTP服务未初始化'))
    }
    const queryParams: Record<string, any> = {}
    if (params && params.equipmentId != null) queryParams.equipmentId = params.equipmentId
    try {
      const response = await http.get(`${this.baseUrl}/toggleRawMaintain`, queryParams)
      return this.handleResponse(response)
    } catch (err) {
      return this.handleError(err)
    }
  }

  async readRawMaintain(dtuNumbers?: string[]) {
    const http = this.httpService || this.getHttpService()
    if (!http) {
      return this.handleError(new Error('HTTP服务未初始化'))
    }
    try {
      const response = await http.post('api/operate?instruction=12345', {"stringArr":dtuNumbers})
      return this.handleResponse(response)
    } catch (err) {
      return this.handleError(err)
    }
  }

  private getHttpService(): any {
    // 尝试从各个可能的位置获取 httpService
    const vue = (window as any).Vue
    if (vue && vue.prototype && vue.prototype.$httpservice) {
      return vue.prototype.$httpservice
    }
    return null
  }

  private handleResponse(response: any): ApiResponse {
    const data = (response && (response.body || response.data)) || response || {}
    return {
      code: data.code || data.status,
      message: data.message || data.msg || '操作成功',
      data: data.data || data.result,
      success: String(data.code) === '200' || data.success
    }
  }

  private handleError(error: any): ApiResponse {
    return {
      code: error.code || -1,
      message: error.message || '请求失败',
      data: null,
      success: false
    }
  }
}

export default TeaMaintainService



// WEBPACK FOOTER //
// ./src/service/TeaMaintainService.ts